export default {
    getContractForm: function(state) {
        return state.contractForm;
    },
    getThreshold(state) {
        return state.threshold;
    }
}
